import React from 'react'
import ProductionProcessPage from './ProductionProcessPage'
import '../styles/_index.scss'

const ProductionProcessContainer = () => {
    return (
        <ProductionProcessPage />
    )
}

export default ProductionProcessContainer